import { Box } from '@razorpay/blade/components';
import {
  SalaryStructureComponent,
  SalaryStructureComponentValueType,
} from 'components/SalaryStructure/types';
import React from 'react';
import { OthersSectionProps } from '../types';
import { ContributionComponentItem } from './ContributionComponentItem';
import { SalaryComponentItem } from './SalaryComponentItem';

const OthersSection: React.FC<OthersSectionProps> = ({
  components,
  contributions,
  onDeleteComponent,
  onUpdateComponent,
  onDeleteContribution,
}) => {
  // Handle value changes
  const handleValueChange = (id: string, component: SalaryStructureComponent, value: string) => {
    onUpdateComponent(id, {
      ...component,
      formula: value,
    });
  };

  // Handle base changes
  const handleBaseChange = (
    id: string,
    component: SalaryStructureComponent,
    baseString: string,
  ) => {
    onUpdateComponent(id, {
      ...component,
      valueType: baseString as SalaryStructureComponentValueType,
    });
  };

  return (
    <Box display="flex" flexDirection="column" gap="spacing.2">
      {components.map((component) => (
        <SalaryComponentItem
          component={component}
          key={component.salaryComponent.id}
          onValueChange={(value) =>
            handleValueChange(component.salaryComponent.id, component, value)
          }
          onBaseChange={(base) => handleBaseChange(component.salaryComponent.id, component, base)}
          onDelete={() => onDeleteComponent(component.salaryComponent.id)}
        />
      ))}
      {contributions.map((contribution) => (
        <ContributionComponentItem
          component={contribution}
          key={contribution.componentId}
          onDelete={() => onDeleteContribution(contribution.componentId)}
        />
      ))}
    </Box>
  );
};

export default OthersSection;
